export function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + ' years';
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + ' months';
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + ' day';
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + ' hrs';
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + ' min';
  }
  return Math.floor(seconds) + ' seconds';
}

//date in string
export function formatDate(date, format) {
  if (date) {
    date = new Date(date);
  } else {
    date = new Date();
  }

  let dd = date.getDate();
  let mm = date.getMonth() + 1; //January is 0!
  let yyyy = date.getFullYear();

  if (dd < 10) {
    dd = '0' + dd;
  }

  if (mm < 10) {
    mm = '0' + mm;
  }

  if (format === 'server') {
    date = dd + '-' + mm + '-' + yyyy;
  } else if (format === 'plus120Days') {
    date.setDate(date.getDate() + 120);
    date =
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2);
  } else if (format === 'tomorrow') {
    date.setDate(date.getDate() + 1);
    date =
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2);
  } else {
    date = yyyy + '-' + mm + '-' + dd;
  }
  return date;
}

export function scrollToSection(scrollTo, scrollDuration) {
  //
  // Set a default for where we're scrolling to
  //

  if (typeof scrollTo === 'string') {
    // Assuming this is a selector we can use to find an element
    var scrollToObj = document.querySelector(scrollTo);

    if (
      scrollToObj &&
      typeof scrollToObj.getBoundingClientRect === 'function'
    ) {
      scrollTo = window.pageYOffset + scrollToObj.getBoundingClientRect().top;
    } else {
      return 'error: No element found with the selector "' + scrollTo + '"';
    }
  } else if (typeof scrollTo !== 'number') {
    // If it's nothing above and not an integer, we assume top of the window
    scrollTo = 0;
  }

  // Set this a bit higher

  var anchorHeightAdjust = 80;
  if (scrollTo > anchorHeightAdjust) {
    scrollTo = scrollTo - anchorHeightAdjust;
  }

  //
  // Set a default for the duration
  //

  if (typeof scrollDuration !== 'number' || scrollDuration < 0) {
    scrollDuration = 1000;
  }

  // Declarations

  var cosParameter = (window.pageYOffset - scrollTo) / 2,
    scrollCount = 0,
    oldTimestamp = window.performance.now();

  function step(newTimestamp) {
    var tsDiff = newTimestamp - oldTimestamp;

    // Performance.now() polyfill loads late so passed-in timestamp is a larger offset
    // on the first go-through than we want so I'm adjusting the difference down here.
    // Regardless, we would rather have a slightly slower animation than a big jump so a good
    // safeguard, even if we're not using the polyfill.

    if (tsDiff > 100) {
      tsDiff = 30;
    }

    scrollCount += Math.PI / (scrollDuration / tsDiff);

    // As soon as we cross over Pi, we're about where we need to be

    if (scrollCount >= Math.PI) {
      return;
    }

    var moveStep = Math.round(
      scrollTo + cosParameter + cosParameter * Math.cos(scrollCount)
    );
    window.scrollTo(0, moveStep);
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
}

export const postData = (url = '', data = {}) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((response) => response.json());
};
